import { Action } from 'redux';

import { RouterErrorType } from '../../state/RouterErrorType';
import { RouterErrorHide, RouterErrorShow } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface ShowRouterErrorAction extends Action {
  errorType: RouterErrorType;
  redirectSiteUrlName: string;
}

export function showRouterError(errorType: RouterErrorType, redirectSiteUrlName?: string): ShowRouterErrorAction {
  return {
    type: RouterErrorShow,
    errorType,
    redirectSiteUrlName: redirectSiteUrlName || ''
  };
}

export const isShowRouterErrorAction = isActionFactory<ShowRouterErrorAction>(RouterErrorShow);

export interface HideRouterErrorAction extends Action {}

export function hideRouterError(): HideRouterErrorAction {
  return {
    type: RouterErrorHide
  };
}

export const isHideRouterErrorAction = isActionFactory<HideRouterErrorAction>(RouterErrorHide);
